"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const focus_trap_react_1 = __importDefault(require("focus-trap-react"));
const react_router_dom_1 = require("react-router-dom");
const useDiversityOverlay_1 = require("../../hooks/useDiversityOverlay");
const DiversityOverlay_1 = require("../DiversityOverlay");
const DiversitySettingsSkipPage = () => {
    const { modelSave } = (0, useDiversityOverlay_1.useDiversityOverlay)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onModelSave = () => {
        modelSave(true);
        navigate(DiversityOverlay_1.DiversityRoutes.SettingsPreview);
    };
    return ((0, jsx_runtime_1.jsx)(focus_trap_react_1.default, { focusTrapOptions: { initialFocus: false, allowOutsideClick: true }, "data-e2e": 'FocusTrap', children: (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'Container', children: [(0, jsx_runtime_1.jsxs)(TextContainer, { "data-e2e": 'TextContainer', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'Title', children: t(i18n_1.Strings.diversity.skipPage.title) }), (0, jsx_runtime_1.jsx)(Subtitle, { "data-e2e": 'Subtitle', children: t(i18n_1.Strings.diversity.skipPage.subtitle) })] }), (0, jsx_runtime_1.jsxs)(ButtonContainer, { "data-e2e": 'ButtonContainer', children: [(0, jsx_runtime_1.jsx)(BackButtonContainer, { "data-e2e": 'BackButtonContainer', children: (0, jsx_runtime_1.jsx)(BackButton, { onClick: () => navigate(-1), "data-e2e": 'BackButton', children: t(i18n_1.Strings.diversity.skipPage.backButton) }) }), (0, jsx_runtime_1.jsx)(ContinueButton, { onClick: onModelSave, "data-e2e": 'ContinueButton', children: t(i18n_1.Strings.common.continue) })] })] }) }));
};
exports.default = DiversitySettingsSkipPage;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(100vw - 80px);
  height: calc(100vh - 80px);
  padding: 40px;

  background: ${({ theme }) => theme.primary};

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    padding-bottom: 32px;
  `)}

  ${ui_1.device.laptopS((0, styled_components_1.css) `
      justify-content: center;
    `)}
`;
const TextContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 580px;
  height: 100%;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    height: unset;
  `)}
`;
const ButtonContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 100%;
  max-width: 580px;
  height: 170px;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    flex-direction: row;
    align-items: flex-start;
    height: 124px;
  `)}

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    flex-direction: row;
    justify-content: center;
    align-items: center;
  `)}
`;
const Title = styled_components_1.default.div `
  padding-bottom: 8px;

  color: ${({ theme }) => theme.text};
  font-size: 24px;
  line-height: 32px;
  text-align: center;
`;
const Subtitle = styled_components_1.default.div `
  padding-top: 8px;

  color: ${({ theme }) => theme.textSecondary};
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`;
const ContinueButton = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.BaseButton) `
  width: 100%;
  height: 48px;
  margin: 0 0 16px 0;
  padding: 8px;

  color: ${({ theme }) => theme.background};
  font-size: 16px;

  background: ${({ theme }) => theme.green};
  border: none;

  border-radius: 4px;

  outline-offset: 4px;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    margin-bottom: 16px;
  `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    width: fit-content;
    max-width: 140px;
    height: 40px;
    padding-left: 24px;
    padding-right: 24px;
    margin-bottom: 0;
  `)}
`);
const BackButton = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.FlatButton) `
  display: flex;
  align-items: center;
  width: fit-content;
  height: 20px;
  margin: 0;
  padding: 8px;

  color: ${({ theme }) => theme.textSecondary};
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  background: transparent;
  border: none;

  outline-offset: 2px;
`);
const BackButtonContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    width: unset;
    margin-right: 40px;
  `)}

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    height: 40px;
  `)}
`;
